// removed by extract-text-webpack-plugin
module.exports = {"container":"_20b8IG_vtPPVDzVZPmPktO","loaderContainer":"_20u4rr-ODpdL7eqJknsLIO","text":"_3uEj2WZGUBHbGLD0Hd3e3d"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ResultsLoader/styles.css
// module id = 393
// module chunks = 0